import { configureStore } from "@reduxjs/toolkit";
import formSlice from "./formSlice";
import pageIndexSlice from "./pageIndexSlice";

// Grab the state from a global variable injected into the server-generated HTML
const preloadedState = window.__PRELOADED_STATE__;

// Allow the passed state to be garbage-collected
delete window.__PRELOADED_STATE__;

export const store = configureStore({
  reducer: {
    form: formSlice,
    pageIndex: pageIndexSlice,
  },
});

// Tell react-snap how to save Redux state
window.snapSaveState = () => ({
  __PRELOADED_STATE__: store.getState(),
});
